



























import { Component, Vue } from "vue-property-decorator";
import { Collection, Document, ChatMessage, Participant, Room, QueuedSong } from "@/types";
import { db, functions } from "@/firebase";

import KaraokeRoom from "@/components/room/KaraokeRoom.vue";
import ModalView from "@/components/design/ModalView.vue";
import RoomSettings from "@/components/room/RoomSettings.vue";

import * as twilio from "twilio-video";

const gravatarPlaceholder = "https://www.gravatar.com/avatar/00000000000000000000000000000000";

@Component({ components: { KaraokeRoom, ModalView, RoomSettings } })
export default class RoomView extends Vue {
  room: Document<Room> = { data: undefined, ref: null };
  participants: Collection<Participant> = { data: [], ref: null };
  songqueue: Collection<QueuedSong> = { data: [], ref: null };
  chat: Collection<ChatMessage> = { data: [], ref: null };
  me: Document<Participant> = { data: null, ref: null };

  ready = false;

  myStream: MediaStream | null = null;
  remoteParticipants: Record<string, twilio.LocalParticipant> = {};
  localParticipant: twilio.LocalParticipant | null = null;

  troom: twilio.Room | null = null;

  async setupRoom(name: string, mediaStream: MediaStream) {
    this.myStream = mediaStream;
    this.$store.commit("setLoading");

    const joinRoomResult = await functions.httpsCallable("joinRoom")(this.$route.params.id);
    const twilioToken = joinRoomResult.data.token;

    twilio.connect(twilioToken, { name: this.$route.params.id, tracks: [] }).then(
      async room => {
        this.troom = room;
        room.on("participantConnected", participant => {
          this.$set(this.remoteParticipants, participant.identity, participant);
        });
        room.on("participantDisconnected", participant => {
          Vue.delete(this.remoteParticipants, participant.identity);
        });
        room.participants.forEach(participant => {
          this.$set(this.remoteParticipants, participant.identity, participant);
        });
        this.localParticipant = room.localParticipant;

        this.$set(this.room, "ref", db.collection("rooms").doc(this.$route.params.id));
        await this.$bind("room.data", this.room.ref);

        this.$set(this.participants, "ref", this.room.ref.collection("participants"));
        await this.$bind("participants.data", this.participants.ref);

        this.$set(this.songqueue, "ref", this.room.ref.collection("songqueue"));
        await this.$bind("songqueue.data", this.songqueue.ref.orderBy("added"));

        this.$set(this.chat, "ref", this.room.ref.collection("chat"));
        await this.$bind("chat.data", this.chat.ref.orderBy("added"));

        this.$set(this.me, "ref", this.participants.ref.doc(this.$store.state.user.data.uid));
        await this.$bind("me.data", this.me.ref);

        const styleNum = Math.floor(Math.random() * 15) + 1;
        const profilePic = this.$store.state.user.data.photoURL || gravatarPlaceholder;
        await this.me.ref.set({ name: name, style: "p" + styleNum, profilePic: profilePic }, { merge: true });

        // Only after loading all the data
        this.$store.commit("setNotLoading");
        this.ready = true;
      },
      error => {
        this.$store.commit("setNotLoading");
        console.error(`Unable to connect to Room: ${error.message}`);
      },
    );
  }

  beforeDestroy() {
    if (this.troom) {
      this.troom.disconnect();
    }
    delete this.myStream;
  }
}
